import { taskAttentionAt } from "./taskAttention"
import type { TaskRecord } from "../persistence/records"

function latestIsoString(a: string | undefined, b: string | undefined): string | undefined {
    if (!a) return b
    if (!b) return a
    return a > b ? a : b
}

export function latestTaskActivityAt(record: TaskRecord, now = Date.now()): string | undefined {
    const sessionActivityAt = record.sessions.reduce<string | undefined>(
        (latest, session) => latestIsoString(latestIsoString(latest, session.createdAt), session.updatedAt),
        undefined
    )
    return latestIsoString(sessionActivityAt ?? record.updatedAt ?? record.createdAt, taskAttentionAt(record.attention, now))
}

export function latestTaskActivityAtFromTimestamps(timestamps: readonly (string | undefined)[]): string | undefined {
    return timestamps.reduce<string | undefined>((latest, timestamp) => latestIsoString(latest, timestamp), undefined)
}

export function readTimestampForActivity(activityAt: string | undefined, now = new Date().toISOString()): string {
    if (!activityAt || activityAt < now) return now

    const activityMs = Date.parse(activityAt)
    if (!Number.isFinite(activityMs)) return activityAt > now ? activityAt : now
    const afterActivity = new Date(activityMs + 1).toISOString()
    return afterActivity > now ? afterActivity : now
}

export function unreadTimestampForActivity(activityAt: string | undefined): string | undefined {
    if (!activityAt) return undefined

    const activityMs = Date.parse(activityAt)
    if (!Number.isFinite(activityMs)) return undefined
    return new Date(Math.max(0, activityMs - 1)).toISOString()
}
